import { useFormContext } from 'react-hook-form';
import { useControlledDocumentTags } from '../../../hooks/use-controlled-document-tags';
import { TagSelector, type TagSelectorVariant } from './DocumentTagSelector';

export interface FormTagSelectorProps {
  name: string;
  organizationId?: string;
  disabled?: boolean;
  variant?: TagSelectorVariant;
  triggerDataTestId?: string;
  addTagButtonDataTestId?: string;
}

export const FormTagSelector = ({
  name,
  organizationId,
  ...props
}: FormTagSelectorProps) => {
  const { setValue, watch } = useFormContext();

  const value: string[] = watch(name) ?? [];

  const tagSelectorProps = useControlledDocumentTags({
    organizationId,
    selectedTags: value,
    onTagsChange: (next: string[]) =>
      setValue(name, next, {
        shouldDirty: true,
      }),
  });

  return (
    <TagSelector
      className="w-full max-w-full"
      {...tagSelectorProps}
      {...props}
    />
  );
};
